import React from "react";
import { useLanguage } from "../../context/LanguageContext";
import { translations } from "../../i18n/translations";
import SectionHeading from "../SectionHeading";
import Reveal from "../Reveal";

const Methodology = () => {
  const { lang } = useLanguage();
  const t = translations[lang].method;

  return (
    <section className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading tag={t.tag} title={t.title} desc={t.desc} center />
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {t.steps.map((s, i) => (
            <Reveal key={s.no} delay={i * 120}>
              <div className="group relative h-full rounded-2xl border border-slate-200 bg-white p-8 hover:border-amber-500/60 hover:shadow-xl hover:shadow-amber-500/5 transition-all duration-300">
                <div className="flex items-center justify-between">
                  <span className="font-display font-extrabold text-5xl text-slate-100 group-hover:text-amber-500/20 transition-colors">
                    {s.no}
                  </span>
                  <span className="w-10 h-10 rounded-full bg-navy-900 group-hover:bg-amber-500 transition-colors flex items-center justify-center text-white group-hover:text-navy-950 font-display font-bold">
                    {i + 1}
                  </span>
                </div>
                <h3 className="mt-4 font-display font-bold text-xl text-navy-900">
                  {s.title}
                </h3>
                <p className="mt-3 text-slate-600 leading-relaxed text-[15px]">
                  {s.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Methodology;
